<template>
<div style="margin-bottom: 50px">
    <vue-headful title="Comments" />

    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">

        <v-row no-gutters>
            <!-- section filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Resource Owner</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="resource_owner" :items="resource_owners" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="filterItems()" hide-details />
                </v-card>
            </v-col>
            <!--./ section filter-->

            <!-- section filter-->
            <v-col cols="6" md="2" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Resource Type</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="resource_type" :items="resource_types" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="filterItems()" hide-details />
                </v-card>
            </v-col>
            <!--./ section filter-->

            <!-- lang filter-->
            <v-col cols="6" md="2" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">User</div>
                    <im-user-search class="im-select ma-0" placeholder="Type here to select ..." @input="filterUser($event)" />
                </v-card>
            </v-col>
            <!--./ lang filter-->

            <!-- lang filter-->
            <v-col cols="6" md="2" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Status</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="status" :items="status_items" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="filterItems()" hide-details />
                </v-card>
            </v-col>
            <!--./ lang filter-->

            <!-- lang filter-->
            <!-- issue date data filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1 im-card-field">
                    <div class="detail font-weight-bold pa-0 ma-0">Created at</div>
                    <div class="d-flex align-center">
                        <v-menu transition="scale-transition" full-width offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly placeholder="After ..." v-model="comp_created_at_from" @input="filterItems()" return-object hide-details></v-text-field>
                            </template>
                            <v-date-picker v-model="created_at_from" no-title @input="filterItems()" width="265">
                                <v-spacer></v-spacer>
                                <v-btn text color="red" @click="created_at_from = null; filterItems()">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-icon small class="mx-1">arrow_forward</v-icon>
                        <v-menu transition="scale-transition" full-width offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly placeholder="Before ..." v-model="comp_created_at_to" @input="filterItems()" hide-details></v-text-field>
                            </template>
                            <v-date-picker v-model="created_at_to" :min="created_at_from" no-title @input="filterItems()" width="265">
                                <v-spacer></v-spacer>
                                <v-btn text color="red" @click="created_at_to = null; filterItems()">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>

                </v-card>
            </v-col>
            <!--./ issue date data filter-->
            <!--./ lang filter-->
        </v-row>

        <!-- SEARCH -->
        <div class="im-search">
            <div class="d-flex align-center">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon medium v-if="$vuetify.breakpoint.smAndDown" class="px-1" @click="dialog_mobile_sort = true">swap_vert</v-icon>
            </div>
            <div class="mx-1 py-2 fields d-flex align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn v-for="field in search_fields" :key="field.value" small rounded depressed class="detail mx-1" :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;" class="mx-1">

            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <im-comment-item :item="item" @click.native="seeItem(item)" :key="item.id" />
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>

        </v-card>

    </v-container>

    <!-- add button -->
    <v-btn color="primary" @click="openCreate()" fab large fixed bottom right>
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add button -->

    <im-comment-modal-edit :dialog="edit_dialog" :id="item_id" @refresh="getItems()" @exit="item_id =null,edit_dialog= false"></im-comment-modal-edit>

    <!--delete dialog-->
    <v-dialog v-model="delete_dialog" max-width="320">
        <v-card>
            <v-card-text>
                Are you sure you want to delete this comment?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red" @click.native="destroy()">
                    Delete
                </v-btn>
                <v-btn color="primary" text @click="delete_dialog=false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete dialog -->

</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import IMCommentItem from '../components/items/CommentCard.vue'
import IMCommentModalEdit from '../components/items/CommentModalEdit.vue'
import IMUserSearch from '../components/utils/UserSearch.vue'
import IMSectionSearch from '../components/utils/SectionSearch.vue'

import defaults from "../components/utils/PropDefaults.js";
import IMTableHeader from '../components/utils/IMTableHeader.vue'
import IMSortField from "../components/utils/IMSortField.vue"
import TipTap from "../components/utils/TipTap.vue";

export default {

    name: `comments`,

    components: {
        'im-comment-item': IMCommentItem,
        'im-user-search': IMUserSearch,
        'im-section-search': IMSectionSearch,
        'im-table-header': IMTableHeader,
        'im-sort-filed': IMSortField,
        'im-comment-modal-edit': IMCommentModalEdit,
        'tip-tap': TipTap,
    },

    data() {
        return {
            // calendar
            date: null,
            menu: false,
            modal: false,
            created_at_from: null,
            created_at_to: null,

            // dialogs
            edit_dialog: false,
            add_dialog: false,
            delete_dialog: false,
            comment_dialog: false,
            current_comment: this.$clone(defaults.comment_item),
            item_id: null,

            // search
            search: null,
            search_ids: null,
            search_place_ids: null,
            search_section_ids: null,
            search_user_ids: null,
            search_filter: ['body'],

            resource_type: null,
            resource_owner: null,
            resource_types: [
                {
                    text: "Article",
                    value: "article",
                }
            ],
            resource_owners: [
                {
                    text: "Destinations",
                    value: "destinations",
                }
            ],

            //search-fields
            search_fields: [
                {
                    text: ' Resource Id',
                    value: 'resource_id',
                    selected: false
                }, {
                    text: 'Comment Id',
                    value: 'id',
                    selected: true
                }, {
                    text: 'Comment Body',
                    value: 'body',
                    selected: false
                }
            ],

            //comment model
            comment: {
                resource_id: null,
                resource_type: null,
                resource_owner: null,
                body: null,
            },

            //languages
            language_items: [
                {
                    text: "English",
                    value: "en"
                }, {
                    text: "Romanian",
                    value: "ro"
                }
            ],

            // status filter
            status: null,
            status_items: [
                {
                    text: "Approved",
                    value: "approved"
                }, {
                    text: "Pending",
                    value: "pending"
                }, {
                    text: "Rejected",
                    value: "rejected"
                }
            ],

            //table header
            items: [],
            im_header: [
                {
                    text: "Id",
                    sortable: false,
                    align: "left",
                    width: "3%"
                }, {
                    text: "Resource id",
                    sortable: false,
                    align: "left",
                    width: "9%"
                }, {
                    text: "Resource Owner",
                    sortable: false,
                    align: "left",
                    width: "11%"
                }, {
                    text: "Resource Type",
                    sortable: false,
                    align: "left",
                    width: "11%"
                }, {
                    text: "Body",
                    sortable: false,
                    align: "left",
                    width: "33%"
                }, {
                    text: "Created at",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "created_at",
                    align: "center",
                    width: "16%"
                }, {
                    text: "Author",
                    sortable: false,
                    align: "left",
                    width: "17%"
                }
            ],

            // table attributes
            search_timeout: 300,
            loading: null,
            is_saving: null,
            pagination: null,
            rppi: [10, 25, 50, 100],
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],

        }
    },

    watch: {

        page: {
            handler() {
                this.getItems()
            }
        },

        size: {
            handler() {
                this.getItems()
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500)
            }
        },

    },

    computed: {
        comp_created_at_from: {
            get: function () {
                return this.formatDate(this.created_at_from);
            },
            set: function (val) {
                return (this.created_at_from = val);
            }
        },
        comp_created_at_to: {
            get: function () {
                return this.formatDate(this.created_at_to);
            },
            set: function (val) {
                return (this.created_at_to = val);
            }
        },
    },

    created() {
        this.getItems()
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format("D MMM YY");
        },

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === '' || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });


            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query params
            let params = {
                params: {
                    search: search,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    orders: orders,
                    dirs: dirs,
                    stamp: stamp,
                    // operational fields
                    status: this.status,
                    author_id: this.search_user_ids,
                    // resource_ids: this.resource_ids,
                    resource_owner: this.resource_owner,
                    resource_type: this.resource_type,
                    start_date: this.created_at_from,
                    end_date: this.created_at_to
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/comments/comments';

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        openCreate() {
            // this.comment = this.$clone(defaults.comment_item);
            this.item_id = null;
            this.edit_dialog = true;
        },

        seeItem(current_item) {
            this.edit_dialog = true;
            this.item_id = current_item.id;
        },

        openEdit(comment) {
            this.comment_dialog = false;
            this.comment = Object.assign({}, comment);
            this.add_dialog = true;
        },

        openDeleteModal(item) {
            this.comment_dialog = false;
            this.delete_comment_id = item.id;
            this.delete_dialog = true;
        },

        destroy() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/comments/comments";

            // call delete endpoint
            this.$axios.delete(endpoint + "/" + this.delete_comment_id) // eslint-disable-next-line
                .then(response => {
                    this.getItems();
                    this.success("Comment was deleted.");
                })
                .catch(error => {
                    this.error('Oops, something went wrong!');
                    console.error(error);
                })
                .finally(() => {
                    this.delete_dialog = false;
                });
        },


        filterUser(user) {
            if(user) {
                this.search_user_ids = user.user_id;
            } else {
                this.search_user_ids = null
            }
            this.filterItems();
        },

        filterItems() {
            this.page = 1;
            this.getItems();
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

    }

}
</script>

<style>
.editor.comments p.is-empty:first-child::before {
    content: 'Write your comment right here!';
    float: left;
    color: #aaa;
    pointer-events: none;
    height: 0;
    font-size: 16px;
}

table th:focus {
    outline: none;
}

.table-comments .title-col {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 150px;
    max-width: 150px;
}

.my-expansion .v-expansion-panel__header {
    height: auto !important;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
}

.my-expansion .v-expansion-panel__container .header__icon {
    display: none;
}

.my-expansion-container {
    height: 48px !important;
}

@media (max-width: 991px) {
    .my-expansion-container {
        height: auto !important;
    }
}
</style>
